/*
 * Copyright (c) 2023. Henry Zilek
 */

import store from "@/store";

const support = {
    getDate: (dbDate) => {
        let t = dbDate.split(/[- :]/);
        let d = new Date(t[0], t[1] - 1, t[2], t[3], t[4], t[5]);
        return d;
    },

    getShortDate: (dbDate) => {
        let t = dbDate.split(/[- :]/);
        let d = new Date(t[0], t[1] - 1, t[2]);
        return d;
    },

    monthBack: () => {
        let date = new Date();
        date.setMonth(date.getMonth() - 1);
        date.setHours(0, 0, 0);
        return date;
    },

    twoWeeksBack: () => {
        let date = new Date();
        date.setDate(date.getDate() - 14);
        return date;

    },


    arrayComp: (arr, obj) => {
        this.sup.hzLog("New Array Compare");
        let a = JSON.stringify(arr);
        let b = JSON.stringify(obj);
        let result = a === b;
        this.sup.hzLog("Vysledek porovnani " + result);
        return result;
    },


    replaceNextLine: (text) => {
        return text.replaceAll("\\n", "<br>")
    },

    hzLog: (msg) => {
        if (store.state.develop)
            console.log(msg);
    },


}

export default support;